import { Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgWizardConfig, NgWizardService, THEME } from 'ng-wizard';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GenericResponseDto } from 'src/app/components/gestione-utenti/gestione-utenti.costants';
import { _ENDPOINT } from '../../../../endpoints/endpoint';
import { NetworkService } from 'src/app/services/network.service';
import { Utility } from '../../../../utility/utility';
import { environment } from '../../../../../environments/environment';
import { Address, BillingAccount, DataCustomerAffiliate, DataCustomerCountry, DataCustomerDepartment, DataCustomerHq, DataCustomerLeadOperator } from './creazione-nuovo-customer-costants';

@Component({
  selector: 'app-creazione-nuovo-customer',
  templateUrl: './creazione-nuovo-customer.component.html',
  styleUrls: ['./creazione-nuovo-customer.component.css']
})
export class CreazioneNuovoCustomerComponent implements OnInit, OnDestroy {

  constructor(private toastr: ToastrManager, private ngWizardService: NgWizardService, private spinner: NgxSpinnerService, private networkService: NetworkService,
    private router: Router) { }

  stepView: string;
  createCustomerDto: DataCustomerLeadOperator;
  isDisabledFormCountry: boolean = false;
  isDisableFormLeadOperator: boolean = false;
  isDisabledFormBOperator: boolean = false;
  isDisableFormAffiliate: boolean = false;
  isModifica: boolean = false;

  config: NgWizardConfig = {
    selected: 0,
    theme: THEME.circles,
    toolbarSettings: {
      showPreviousButton: false,
      showNextButton: false,
    },
    anchorSettings: {
      anchorClickable: false,
      enableAnchorOnDoneStep: false
    }
  };

  destroy$ = new Subject<boolean>();
  responseSaveCustomer: GenericResponseDto;
  responseValidCustomer: GenericResponseDto;

  tendinaAgreements: any[] = [];

  regexSla: string = "^(0\\d|1[0-2]):([0-2]\\d|30):([0-1]\\d|2[0-3])$";

  regexSlaHoursMinutes: string = "^(\\d)+:([0-5][0-9]|[0-9])$";

  ngOnInit(): void {
    this.stepView = 'customer-lead-operator';
    this.initializeCreateCustomerDto();
    this.initializeTendinaAgreements();
  }

  initializeCreateCustomerDto() {
    this.createCustomerDto = {
      leadOperatorGlobalCustomerId: '',
      leadOperator: '',
      globalCustomerName: '',
      note: '',
      listBOperator: []
    }
  }

  viewCustomerDataCountry(): boolean {
    return 'customer-data-country' == this.stepView;
  }

  viewCustomerDataAffiliate(): boolean {
    return 'customer-data-affiliate' == this.stepView;
  }

  viewCustomerDataDepartment(): boolean {
    return 'customer-data-department' == this.stepView;
  }

  viewCustomerDataBOperator(): boolean {
    return 'customer-data-bOperator' == this.stepView;
  }

  viewCustomerDataLeadOperator(): boolean {
    return 'customer-lead-operator' == this.stepView;
  }



  changeStepView(stepView: string) {
    this.stepView = stepView;
    this.ngWizardService.next();
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  previousStepView(stepView: string) {
    this.stepView = stepView;
    this.ngWizardService.previous();
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  updateCustomerDto(createCustomerDto: DataCustomerLeadOperator) {
    this.createCustomerDto = createCustomerDto;
  }

  saveCustomer(createCustomerDto: DataCustomerLeadOperator) {
    if (this.validaSaveCustomer(createCustomerDto)) {
      this.validaNewCustomerBe(createCustomerDto);
    }
  }

  validaSaveCustomer(createCustomerDto: DataCustomerLeadOperator): boolean {
    let result: boolean = true;
    result = this.validaCampiObbligatori(createCustomerDto) && this.validaLocalAgreements(createCustomerDto)
      && this.validaLocalAgreementGiaAssociato(createCustomerDto) && this.checkIdsCountryAffiliateDepartment(createCustomerDto);

    return result;
  }

  validaCampiObbligatori(createCustomerDto: DataCustomerLeadOperator): boolean {
    let result: boolean = true;

    result = this.validaCampiObbligatoriCustomerLeadOperator(createCustomerDto)
      && this.validaCampiObbligatoriCustomerBOperator(createCustomerDto)
      && this.validaCampiObbligatoriCustomerCountry(createCustomerDto);

    return result;
  }


  validaCampiObbligatoriCustomerCountry(createCustomerDto: DataCustomerLeadOperator): boolean {
    let result: boolean = true;
    if (createCustomerDto && createCustomerDto.listBOperator && createCustomerDto.listBOperator.length > 0) {
      for (let elem of createCustomerDto.listBOperator) {
        if (elem && elem.listCountry && elem.listCountry.length > 0) {
          for (let country of elem.listCountry) {
            if (!country.countryName) {
              this.toastr.errorToastr('Country Name is mandatory for all Customer Data Country!', 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
              return false;
            }
            if ((!country.customerBillingAccount || country.customerBillingAccount.length == 0) && (!country.listAffiliate || country.listAffiliate.length == 0)) {
              this.toastr.errorToastr('Customer Billing Account is mandatory for all Customer Data Country!', 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
              return false;
            }
            if (!this.validaBillingAccountCountry(country, country.customerBillingAccount)) {
              return false;
            }
            if (!country.deliveryAddress) {
              this.toastr.errorToastr('Delivery Address is mandatory for all Customer Data Country!', 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
              return false;
            }
            if (!this.validaDeliveryAddressCountry(country, country.deliveryAddress) ) {
              return false;
            }
            if (!this.validaCampiObbligatoriCustomerAffiliate(country)) {
              return false;
            }
            if (!country.sla) {
              this.toastr.errorToastr('Sla is mandatory for all Customer Data Country!', 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
              return false;
            }
            let regex = new RegExp(this.regexSlaHoursMinutes);
            if (!regex.test(country.sla)) {
              this.toastr.errorToastr('Wrong sla format! Sla Format Must Be (Number Of Hours:Number of minutes)', 'Error', { 'animate': 'slideFromRight', 'timeout': '1000' });
              return false;
            }
          }
        }
      }
    }
    return result;
  }

  validaBillingAccountCountry(country: DataCustomerCountry, billingAccount: BillingAccount[]) {
    let result: boolean = true;
    if (billingAccount && billingAccount.length == 0 && (!country.listAffiliate || country.listAffiliate.length == 0)) {
      this.toastr.errorToastr('Billing Account is mandatory in Customer Data Country ' + country.countryCustomerId, 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    for (let acc of billingAccount) {
      if (!acc.id && (!country.listAffiliate || country.listAffiliate.length == 0)) {
        this.toastr.errorToastr('Id is mandatory in Billing Account of Customer Data Country ' + country.countryCustomerId, 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
        return false;
      }
    }
    return result;
  }

  validaDeliveryAddressCountry(country: DataCustomerCountry, acc: Address) {
    let result: boolean = true;



    if (!acc.name && country.listAffiliate && country.listAffiliate.length==0) {
      this.toastr.errorToastr('Name is mandatory in Address of Customer Data Country ' + country.countryCustomerId, 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    if (!acc.streetNr && country.listAffiliate && country.listAffiliate.length==0) {
      this.toastr.errorToastr('StreetNumber is mandatory in Address of Customer Data Country ' + country.countryCustomerId, 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    if (!acc.streetName && country.listAffiliate && country.listAffiliate.length==0) {
      this.toastr.errorToastr('Street is mandatory in Address of Customer Data Country ' + country.countryCustomerId, 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    if (!acc.postCode && country.listAffiliate && country.listAffiliate.length==0) {
      this.toastr.errorToastr('PostalCode is mandatory in Address of Customer Data Country ' + country.countryCustomerId, 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    if (!acc.city && country.listAffiliate && country.listAffiliate.length==0) {
      this.toastr.errorToastr('City is mandatory in Address of Customer Data Country ' + country.countryCustomerId, 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    if (!acc.country && country.listAffiliate && country.listAffiliate.length==0) {
      this.toastr.errorToastr('Country is mandatory in Address of Customer Data Country ' + country.countryCustomerId, 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }




    return result;
  }

  validaBillingAccountAffiliate(affiliate: DataCustomerAffiliate, billingAccount: BillingAccount[]) {
    let result: boolean = true;
    if (billingAccount && billingAccount.length == 0 && (!affiliate.listDepartment || affiliate.listDepartment.length == 0)) {
      this.toastr.errorToastr('Billing Account is mandatory in Affiliate ' + affiliate.affiliateId, 'Error Customer Data Affiliate', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    for (let acc of billingAccount) {
      if (!acc.id && (!affiliate.listDepartment || affiliate.listDepartment.length == 0)) {
        this.toastr.errorToastr('Id is mandatory in Billing Account of Affiliate ' + affiliate.affiliateId, 'Error Customer Data Affiliate', { 'animate': 'slideFromRight', 'timeout': '3000' });
        return false;
      }
    }
    return result;
  }

  validaDeliveryAddressAffiliate(affiliate: DataCustomerAffiliate, acc: Address) {
    let result: boolean = true;



    if (!acc.name) {
      this.toastr.errorToastr('Name is mandatory in Address of Customer Data Affiliate ' + affiliate.affiliateId, 'Error Customer Data Affiliate', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    if (!acc.streetNr) {
      this.toastr.errorToastr('StreetNumber is mandatory in Address of Customer Data Affiliate ' + affiliate.affiliateId, 'Error Customer Data Affiliate', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    if (!acc.streetName) {
      this.toastr.errorToastr('Street is mandatory in Address of Customer Data Affiliate ' + affiliate.affiliateId, 'Error Customer Data Affiliate', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    if (!acc.postCode) {
      this.toastr.errorToastr('PostalCode is mandatory in Address of Customer Data Affiliate ' + affiliate.affiliateId, 'Error Customer Data Affiliate', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    if (!acc.city) {
      this.toastr.errorToastr('City is mandatory in Address of Customer Data Affiliate ' + affiliate.affiliateId, 'Error Customer Data Affiliate', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    if (!acc.country) {
      this.toastr.errorToastr('Country is mandatory in Address of Customer Data Affiliate ' + affiliate.affiliateId, 'Error Customer Data Affiliate', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }




    return result;
  }

  validaBillingAccountDepartment(department: DataCustomerDepartment, billingAccount: BillingAccount[]) {
    let result: boolean = true;
    if (billingAccount && billingAccount.length == 0) {
      this.toastr.errorToastr('Billing Account is mandatory in Department ' + department.departmentId, 'Error Customer Data Department', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    for (let acc of billingAccount) {
      if (!acc.id) {
        this.toastr.errorToastr('Id is mandatory in Billing Account of Department ' + department.departmentId, 'Error Customer Data Department', { 'animate': 'slideFromRight', 'timeout': '3000' });
        return false;
      }
   }
    return result;
  }

  validaDeliveryAddressDepartment(department: DataCustomerDepartment, acc: Address) {
    let result: boolean = true;



    if (!acc.name) {
      this.toastr.errorToastr('Name is mandatory in Address of Customer Data Department ' + department.departmentId, 'Error Customer Data Department', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    if (!acc.streetNr) {
      this.toastr.errorToastr('StreetNumber is mandatory in Address of Customer Data Department ' + department.departmentId, 'Error Customer Data Department', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    if (!acc.streetName) {
      this.toastr.errorToastr('Street is mandatory in Address of Customer Data Department ' + department.departmentId, 'Error Customer Data Department', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    if (!acc.postCode) {
      this.toastr.errorToastr('PostalCode is mandatory in Address of Customer Data Department ' + department.departmentId, 'Error Customer Data Department', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    if (!acc.city) {
      this.toastr.errorToastr('City is mandatory in Address of Customer Data Department ' + department.departmentId, 'Error Customer Data Department', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    if (!acc.country) {
      this.toastr.errorToastr('Country is mandatory in Address of Customer Data Department ' + department.departmentId, 'Error Customer Data Department', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }




    return result;
  }

  validaCampiObbligatoriCustomerAffiliate(country: DataCustomerCountry): boolean {
    let result: boolean = true;
    if (country && country.listAffiliate && country.listAffiliate.length > 0) {
      for (let affiliate of country.listAffiliate) {
        if (!affiliate.affiliateName) {
          this.toastr.errorToastr('Affiliate Name is mandatory in Customer Data Affiliate of country ' + country.countryCustomerId, 'Error Customer Data Affiliate', { 'animate': 'slideFromRight', 'timeout': '3000' });
          return false;
        }
        if (!affiliate.affiliateId) {
          this.toastr.errorToastr('Affiliate Id is mandatory in Customer Data Affiliate of country ' + country.countryCustomerId, 'Error Customer Data Affiliate', { 'animate': 'slideFromRight', 'timeout': '3000' });
          return false;
        }

        if ((!affiliate.customerBillingAccount || affiliate.customerBillingAccount.length == 0) && (!affiliate.listDepartment || affiliate.listDepartment.length == 0)) {
          this.toastr.errorToastr('Billing is mandatory in Customer Data Affiliate of country ' + country.countryCustomerId, 'Error Customer Data Affiliate', { 'animate': 'slideFromRight', 'timeout': '3000' });
          return false;
        }

        if (!this.validaBillingAccountAffiliate(affiliate, affiliate.customerBillingAccount)) {
          return false;
        }

        if (!affiliate.deliveryAddress) {
          this.toastr.errorToastr('Delivery Address is mandatory in Customer Data Affiliate of country ' + country.countryCustomerId, 'Error Customer Data Affiliate', { 'animate': 'slideFromRight', 'timeout': '3000' });
          return false;
        }

        if (!this.validaDeliveryAddressAffiliate(affiliate, affiliate.deliveryAddress)) {
          return false;
        }

        if (!this.validaCampiObbligatoriCustomerDepartment(affiliate)) {
          return false;
        }

      }
    }
    return result;
  }

  validaCampiObbligatoriCustomerDepartment(affiliate: DataCustomerAffiliate): boolean {
    let result: boolean = true;
    if (affiliate && affiliate.listDepartment && affiliate.listDepartment.length > 0) {
      for (let department of affiliate.listDepartment) {
        if (!department.departmentName) {
          this.toastr.errorToastr('Department Name is mandatory in Customer Data Department of affiliate ' + affiliate.affiliateId, 'Error Customer Data Department', { 'animate': 'slideFromRight', 'timeout': '3000' });
          return false;
        }
        if (!department.departmentId) {
          this.toastr.errorToastr('Affiliate Id is mandatory in Customer Data Department of affiliate ' + affiliate.affiliateId, 'Error Customer Data Department', { 'animate': 'slideFromRight', 'timeout': '3000' });
          return false;
        }

        if (!department.customerBillingAccount || department.customerBillingAccount.length == 0) {
          this.toastr.errorToastr('Billing is mandatory in Customer Data Department of affiliate ' + affiliate.affiliateId, 'Error Customer Data Department', { 'animate': 'slideFromRight', 'timeout': '3000' });
          return false;
        }

        if (!this.validaBillingAccountDepartment(department, department.customerBillingAccount)) {
          return false;
        }

        if (!department.deliveryAddress) {
          this.toastr.errorToastr('Delivery Address is mandatory in Customer Data Department of affiliate ' + affiliate.affiliateId, 'Error Customer Data Department', { 'animate': 'slideFromRight', 'timeout': '3000' });
          return false;
        }

        if (!this.validaDeliveryAddressDepartment(department, department.deliveryAddress)) {
          return false;
        }

      }
    }
    return result;
  }

  validaNewCustomerBe(createCustomerDto: DataCustomerLeadOperator) {

    this.spinner.show("sp1");
    let urlUsers: string = environment.basePath + _ENDPOINT.validationNewCustomer;
    let data = Utility.createBodyForPostRequest(createCustomerDto);
    this.networkService.post(urlUsers, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {

        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.responseValidCustomer = JSON.parse(response.body);
            if (this.responseValidCustomer && this.responseValidCustomer.status == 'OK') {

              this.spinner.hide("sp1");
              this.saveNewCustomer(createCustomerDto);



            } else if (this.responseValidCustomer && this.responseValidCustomer.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.responseValidCustomer.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

            }


          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during the save validation', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          }
        }
        else {

          if (response && response.status) {
            this.responseValidCustomer = response;
            if (this.responseValidCustomer && this.responseValidCustomer.status == 'OK') {

              this.spinner.hide("sp1");
              this.saveNewCustomer(createCustomerDto);



            } else if (this.responseValidCustomer && this.responseValidCustomer.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.responseValidCustomer.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

            }
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during Valid Customer', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }

        }





      },
        err => {
          this.spinner.hide("sp1");
          console.error(err);
          this.toastr.errorToastr('Error during Valid Customer', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });




        });
  }

  saveNewCustomer(createCustomerDto: DataCustomerLeadOperator) {

    this.spinner.show("sp1");
    let urlUsers: string = environment.basePath + _ENDPOINT.saveCustomer;
    let data = Utility.createBodyForPostRequest(createCustomerDto);
    this.networkService.post(urlUsers, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {

        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.responseSaveCustomer = JSON.parse(response.body);
            if (this.responseSaveCustomer && this.responseSaveCustomer.status == 'OK') {

              this.spinner.hide("sp1");
              this.toastr.successToastr('Customer added successfully!', 'Customer added result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.router.navigate(['customer-data-entry']);


            } else if (this.responseSaveCustomer && this.responseSaveCustomer.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.responseSaveCustomer.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.router.navigate(['customer-data-entry']);
            }


          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during the save customer', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            this.router.navigate(['customer-data-entry']);
          }

        }
        else {

          if (response && response.status) {
            this.responseSaveCustomer = response;
            if (this.responseSaveCustomer && this.responseSaveCustomer.status == 'OK') {

              this.spinner.hide("sp1");
              this.toastr.successToastr('Customer added successfully!', 'Customer added result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.router.navigate(['customer-data-entry']);


            } else if (this.responseSaveCustomer && this.responseSaveCustomer.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.responseSaveCustomer.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.router.navigate(['customer-data-entry']);
            }

          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during Save Customer', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }

        }





      },
        err => {
          this.spinner.hide("sp1");
          console.error(err);
          this.toastr.errorToastr('Error during Save Customer', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });




        });
  }

  initializeTendinaAgreements() {

    this.spinner.show("sp1");
    let urlUsers: string = environment.basePath + _ENDPOINT.getAllAgreements;
    let data = {
      body: ''
    }
    this.networkService.post(urlUsers, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {

        if (this.networkService.checkEnvironmentIsDev()) {

          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.tendinaAgreements = JSON.parse(response.body);
            let tendinaTemp: any[] = [];
            let data: any = {
              id: '',
              startDate: '',
              expirationDate: '',
              flagAssociato: '',
              typeOfLocalCustomer: '',
              idsLocalCustomerAssociated: []
            }
            tendinaTemp.push(data);
            let newArray: any[] = tendinaTemp.concat(this.tendinaAgreements);
            this.tendinaAgreements = newArray;
            this.spinner.hide("sp1");

          } else {

            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during Agreements Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          }

        }
        else {

          if (response && Array.isArray(response)) {
            this.spinner.hide('sp1');
            this.tendinaAgreements = response;
            let tendinaTemp: any[] = [];
            let data: any = {
              id: '',
              startDate: '',
              expirationDate: '',
              flagAssociato: '',
              typeOfLocalCustomer: '',
              idsLocalCustomerAssociated: []
            }
            tendinaTemp.push(data);
            let newArray: any[] = tendinaTemp.concat(this.tendinaAgreements);
            this.tendinaAgreements = newArray;
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during Agreements Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }


        }





      },
        err => {

          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during Agreements Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          console.error(err);



        });
  }

  validaLocalAgreements(createCustomerDto: DataCustomerLeadOperator): boolean {
    let result: boolean = true;
    if (createCustomerDto && createCustomerDto.listBOperator && createCustomerDto.listBOperator.length > 0) {
      for (let elem of createCustomerDto.listBOperator) {
        if (elem.listCountry && elem.listCountry.length > 0) {
          for (let country of elem.listCountry) {
            if (country.localAgreement) {
              let sameLocalAgreementForCountriesOfTheSameBo: any = elem.listCountry.find(x => x.localAgreement == country.localAgreement
                && (x.countryCustomerId != country.countryCustomerId || x.globalCustomerId != country.globalCustomerId));
              if (sameLocalAgreementForCountriesOfTheSameBo) {
                let msg: string = "Local agreements must be different between countries of the BO" + country.globalCustomerId;
                this.toastr.errorToastr(msg, 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
                return false;
              } 

            }
            else if (!country.localAgreement && country.listAffiliate && country.listAffiliate.length == 0) {
              let msg: string = "Associate a local agreement for the country id " + country.countryCustomerId;
              this.toastr.errorToastr(msg, 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
              return false;
            }
            else if (!country.localAgreement && country.listAffiliate && country.listAffiliate.length > 0) {
              let numAffiliate: number = 0;
              for (let affiliate of country.listAffiliate) {
                numAffiliate = numAffiliate + 1;
                if (!affiliate.localAgreement && affiliate.listDepartment && affiliate.listDepartment.length == 0) {
                  let msg: string = "Associate a local agreement for the affiliate id " + affiliate.affiliateId;
                  this.toastr.errorToastr(msg, 'Error Customer Data Affiliate', { 'animate': 'slideFromRight', 'timeout': '3000' });
                  return false;
                } else if (!affiliate.localAgreement && affiliate.listDepartment && affiliate.listDepartment.length > 0) {
                  let numDepartment: number = 0;
                  for (let department of affiliate.listDepartment) {
                    numDepartment = numDepartment + 1;
                    if (!department.localAgreement) {
                      let msg: string = "Associate a local agreement for the department id " + department.departmentId;
                      this.toastr.errorToastr(msg, 'Error Customer Data Department', { 'animate': 'slideFromRight', 'timeout': '3000' });
                      return false;
                    } else {
                      for (let bo of createCustomerDto.listBOperator) {
                        if (bo.listCountry && bo.listCountry.length > 0) {
                          for (let paese of bo.listCountry) {
                            if (paese.listAffiliate && paese.listAffiliate.length > 0) {
                              for (let aff of paese.listAffiliate) {
                                if (aff.listDepartment && aff.listDepartment.length > 0) {
                                  let sameLocalAgreementForCountriesOfTheSameBo: any = aff.listDepartment.find(x => x.localAgreement == department.localAgreement
                                    && x.affiliateId != affiliate.affiliateId);
                                  if (sameLocalAgreementForCountriesOfTheSameBo) {
                                    let affIdOfDepid: string = sameLocalAgreementForCountriesOfTheSameBo.affiliateId;
                                    let affiSeleted: any = this.searchAffiliateId(affIdOfDepid, createCustomerDto);
                                    if (affiSeleted) {
                                      if (affiSeleted.countryCustomerId != affiliate.countryCustomerId
                                        || affiSeleted.globalCustomerId != affiliate.globalCustomerId) {
                                        let msg: string = "Local agreements must be different between departments of different affiliates of different countries for the BO" + affiliate.globalCustomerId;
                                        this.toastr.errorToastr(msg, 'Error Customer Data Affiliate', { 'animate': 'slideFromRight', 'timeout': '3000' });
                                        return false;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                } else if (affiliate.localAgreement) {
                  for (let bo of createCustomerDto.listBOperator) {
                    if (bo.listCountry && bo.listCountry.length > 0) {
                      for (let paese of bo.listCountry) {
                        if (paese.listAffiliate && paese.listAffiliate.length > 0) {
                          let sameLocalAgreementForCountriesOfTheSameBo: any = paese.listAffiliate.find(x => x.localAgreement == affiliate.localAgreement
                            && (x.countryCustomerId != affiliate.countryCustomerId || x.globalCustomerId != affiliate.globalCustomerId));
                          if (sameLocalAgreementForCountriesOfTheSameBo) {
                            let msg: string = "Local agreements must be different between affiliates of different countries for the BO" + affiliate.globalCustomerId;
                            this.toastr.errorToastr(msg, 'Error Customer Data Affiliate', { 'animate': 'slideFromRight', 'timeout': '3000' });
                            return false;
                          }
                        }
                      }
                    }
                  }
                }
              }
              /* Rilassamento vincolo per fix [FREEMOVE_376]*/
              /*if (numAffiliate == country.listAffiliate.length) {
                for (let i = 0; i < country.listAffiliate.length; i++) {
                  for (let j = i + 1; j < country.listAffiliate.length; j++) {
                    if (country.listAffiliate[i].localAgreement != country.listAffiliate[j].localAgreement) {
                      let msg: string = "Country affiliates with country id " + country.countryCustomerId + " and country " + country.countryName + " must have the same local agreement";
                      this.toastr.errorToastr(msg, 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
                      return false;
                    }
                  }
                }
              }*/
            }
          }
        }
      }
    }
    return result;
  }

  validaLocalAgreementGiaAssociato(createCustomerDto: DataCustomerLeadOperator): boolean {
    let result: boolean = true;
    let agreement: any = [];
    if (createCustomerDto && createCustomerDto.listBOperator && createCustomerDto.listBOperator.length > 0) {
      for (let elem of createCustomerDto.listBOperator) {
        if (elem.listCountry && elem.listCountry.length > 0) {
          for (let country of elem.listCountry) {
            if (country.localAgreement) {
              agreement = this.tendinaAgreements.find(x => x.id == country.localAgreement);
              if (agreement && agreement.flagAssociato && agreement.flagAssociato == "Y") {
                let msg: string = "Local agreement for the country id " + country.countryCustomerId + " and country " + country.countryName + " already associated with another affiliate / country";
                this.toastr.errorToastr(msg, 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
                return false;
              }

            }
            else if (!country.localAgreement && country.listAffiliate && country.listAffiliate.length > 0) {
              for (let affiliate of country.listAffiliate) {
                if (affiliate.localAgreement) {
                  agreement = this.tendinaAgreements.find(x => x.id == affiliate.localAgreement);
                  if (agreement && agreement.flagAssociato && agreement.flagAssociato == "Y") {
                    let msg: string = "Local agreement for the affiliate id " + affiliate.affiliateId + " already associated with another affiliate / country";
                    this.toastr.errorToastr(msg, 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
                    return false;
                  }
                }
              }
            }
          }
        }
      }
    }
    return result;
  }

  validaCampiObbligatoriCustomerLeadOperator(createCustomerDto: DataCustomerLeadOperator): boolean {
    let result: boolean = true;
    if (createCustomerDto) {
      if (!createCustomerDto.globalCustomerName) {
        this.toastr.errorToastr('Global Customer Name is mandatory in LO Global Customer Data!', 'Error LO Global Customer Data', { 'animate': 'slideFromRight', 'timeout': '3000' });
        return false;
      }
      if (!createCustomerDto.leadOperator) {
        this.toastr.errorToastr('Lead Operator is mandatory in LO Global Customer Data!', 'Error LO Global Customer Data', { 'animate': 'slideFromRight', 'timeout': '3000' });
        return false;
      }

      if (!createCustomerDto.leadOperatorGlobalCustomerId) {
        this.toastr.errorToastr('Global Customer Id is mandatory in LO Global Customer Data!', 'Error LO Global Customer Data', { 'animate': 'slideFromRight', 'timeout': '3000' });
        return false;
      }
    }
    return result;
  }

  validaCampiObbligatoriCustomerBOperator(createCustomerDto: DataCustomerLeadOperator): boolean {
    let result: boolean = true;
    if (createCustomerDto && createCustomerDto.listBOperator && createCustomerDto.listBOperator.length > 0) {
      for (let elem of createCustomerDto.listBOperator) {
        if (!elem.bOperator) {
          this.toastr.errorToastr('Operator is mandatory in BO GLobal Customer Data!', 'Error BO GLobal Customer Data', { 'animate': 'slideFromRight', 'timeout': '3000' });
          return false;
        }

        if (!elem.bOperatorGlobalCustomerId) {
          this.toastr.errorToastr('Global Customer Id is mandatory in BO GLobal Customer Data!', 'Error BO GLobal Customer Data', { 'animate': 'slideFromRight', 'timeout': '3000' });
          return false;
        }
      }

    }
    return result;
  }

  checkIdsCountryAffiliateDepartment(createCustomerDto: DataCustomerLeadOperator) {
    let result: boolean = true;
    if (createCustomerDto && createCustomerDto.listBOperator
      && createCustomerDto.listBOperator.length > 0) {
      for (let bo of createCustomerDto.listBOperator) {
        if (bo.listCountry && bo.listCountry.length > 0) {
          for (let country of bo.listCountry) {
            if (country.countryCustomerId) {
              let index = country.countryCustomerId.indexOf("_");
              if (index >= 0) {
                this.toastr.errorToastr('Country Customer Id ' + country.countryCustomerId + ' cannot contain _', 'Error Customer Data Country', { 'animate': 'slideFromRight', 'timeout': '3000' });
                return false;
              }
            }
            if (country.listAffiliate && country.listAffiliate.length > 0) {
              for (let affiliate of country.listAffiliate) {
                if (affiliate.affiliateId) {
                  let indexAff = affiliate.affiliateId.indexOf("_");
                  if (indexAff >= 0) {
                    this.toastr.errorToastr('Affiliate Id ' + affiliate.affiliateId + ' cannot contain _', 'Error Customer Data Affiliate', { 'animate': 'slideFromRight', 'timeout': '3000' });
                    return false;
                  }
                }
                if (affiliate.listDepartment && affiliate.listDepartment.length > 0) {
                  for (let department of affiliate.listDepartment) {
                    if (department.departmentId) {
                      let indexDep = department.departmentId.indexOf("_");
                      if (indexDep >= 0) {
                        this.toastr.errorToastr('Department Id ' + department.departmentId + ' cannot contain _', 'Error Customer Data Department', { 'animate': 'slideFromRight', 'timeout': '3000' });
                        return false;
                      }
                    }
                  }
                }

              }
            }
          }
        }
      }
    }
    return result;
  }

  searchAffiliateId(id: string, createCustomerDto: DataCustomerLeadOperator) {
    let result: any = {};
    for (let bo of createCustomerDto.listBOperator) {
      for (let country of bo.listCountry) {
        for (let aff of country.listAffiliate) {
          if (aff.affiliateId == id) {
            return aff;
          }
        }
      }
    }
    return result;
  }

  goToCustomersView(){
    this.router.navigate(['customer-data-entry']);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
